import { MouseEvent } from 'react';
import { Baby } from '@snapi/types';
import { DateUtils } from '@snapi/utils';
import { TextButton } from '@snapi/luxury';
import { differenceInDays } from 'date-fns';
import clsx from 'clsx';

const asAge = (dob: string) => {
  const ageInMontsh = DateUtils.ageInMonths(dob);

  if (ageInMontsh <= 0) {
    const days = differenceInDays(Date.now(), new Date(dob));
    if (days <= 0) {
      return 'waiting';
    } else {
      return `${days} days`;
    }
  } else if (ageInMontsh === 1) {
    return '1 month';
  } else {
    return `${ageInMontsh} months`;
  }
};

export interface FirstBabyCardProps {
  baby: Pick<Baby, 'name' | 'dob'>;
  onEdit?(): void;
  babiesNames: string[];
  open: boolean;
}

export const FirstBabyCard: React.FC<FirstBabyCardProps> = ({
  baby: { name, dob },
  onEdit,
  babiesNames,
  open,
}) => {
  const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onEdit?.();
  };
  const widthContainerNames =
    babiesNames.length <= 1 ? 60 : babiesNames.length * 30 + 30;

  const getColorClass = (index: number) => {
    if (index === 0) {
      return 'bg-purple';
    } else if (index === 1) {
      return 'bg-green';
    } else if (index === 2) {
      return 'bg-pink';
    } else if (index === 3) {
      return 'bg-yellow';
    } else if (index === 4) {
      return 'bg-blue';
    } else {
      return 'bg-purple';
    }
  };

  return (
    <div className="flex flex-1 justify-center items-center gap-3 px-2.5 py-3 rounded-[10px]">
      <div
        className={
          !open
            ? `flex relative h-[60px] w-[${widthContainerNames}px]`
            : 'w-[60px]'
        }
      >
        {open ? (
          <div className="flex justify-center items-center text-white h-[60px] w-[60px] rounded-full bg-purple">
            <h3 className="uppercase">{name.substring(0, 1)}</h3>
          </div>
        ) : (
          babiesNames.map((item, index) => (
            <div
              key={index}
              className={`absolute top-0 left-0 flex justify-center items-center text-white h-[60px] w-[60px] rounded-full  ${getColorClass(
                index
              )}`}
              style={{
                transform: `translateX(${index * 30}px)`,
                zIndex: babiesNames.length - index,
              }}
            >
              <h3 className="uppercase">{item}</h3>
            </div>
          ))
        )}
      </div>
      <div className="flex flex-1 gap-1 flex-col sm:flex-row sm:gap-2">
        <h5
          className={clsx(
            babiesNames.length === 2 && !open && 'ml-[90px]',
            babiesNames.length === 4 && !open && 'ml-[150px]',
            babiesNames.length === 5 && !open && 'ml-[180px]',
            babiesNames.length === 6 && !open && 'ml-[210px]',
            babiesNames.length === 7 && !open && 'ml-[240px]',
            'mt-1'
          )}
        >
          {name}, {asAge(dob)}
        </h5>
        {onEdit && (
          <div
            className={clsx(
              babiesNames.length === 2 && !open && 'ml-[90px] sm:ml-0',
              babiesNames.length === 4 && !open && 'ml-[150px] sm:ml-0',
              babiesNames.length === 5 && !open && 'ml-[180px] sm:ml-0',
              babiesNames.length === 6 && !open && 'ml-[210px] sm:ml-0',
              babiesNames.length === 7 && !open && 'ml-[240px] sm:ml-0',
              'mt-[2px]'
            )}
          >
            <TextButton onClick={handleEdit} secondary>
              (info)
            </TextButton>
          </div>
        )}
      </div>
    </div>
  );
};
